import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { CALENDAR_SETTINGS_ROUTES } from "../../modules/constants";

export default () => ({
  path: CALENDAR_SETTINGS_ROUTES.SCHOOL_WISE_INFORMATION,
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "calendar-settings-school-wise-information" */ "./components"
    ).then(m => m.default)
  ),
});
